<ion-list>
  <div *ngFor="let question of questions">

    <div *ngIf="question.id === firstIncrementalId" class="promotional-title">
      Cuéntanos un poco más
    </div>

    <div [ngSwitch]="question.type">

      <!-- multiple-select -->
      <ion-item *ngIf="question.type === 'multiple-select' && question.incremental_info === false">
        <ion-select [formControl]="question.formControl" interface="popover" [label]="question.label"
          label-placement="stacked" [multiple]="true" [placeholder]="question.placeholder || 'Seleccione una opción'">
          <ion-select-option *ngFor="let option of question.options" [value]="option.value">
            {{ option.label }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="question.type === 'multiple-select' && question.incremental_info === true">
        <ion-input readonly [value]="question.formControl.value" (click)="openFieldModalForQuestion(question)" [label]="question.label"
          label-placement="stacked" [placeholder]="question.placeholder || ''">
        </ion-input>
      </ion-item>

      <!-- select -->
      <ion-item *ngIf="question.type === 'select' && question.incremental_info === false">
        <ion-select [formControl]="question.formControl" interface="popover" [label]="question.label"
          label-placement="stacked" [placeholder]="question.placeholder || 'Seleccione una opción'">
          <ion-select-option *ngFor="let option of question.options" [value]="option.value">
            {{ option.label }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="question.type === 'select' && question.incremental_info === true">
        <ion-input readonly [value]="question.formControl.value" (click)="openFieldModalForQuestion(question)" [label]="question.label"
          [placeholder]="question.placeholder || ''" label-placement="stacked">
        </ion-input>
      </ion-item>

      <ng-container *ngSwitchCase="'dynamic-select'">

        <!-- special case for store -->
        <ion-item lines="none" class="item-bordered" *ngIf="question.id === 'store_id'">

          <ion-input label-placement="stacked" [value]="getStoreLabel(question.formControl.value)" [label]="question.label"
            placeholder="Seleccionar tienda" readonly (click)="openStoreSelector(question)">
          </ion-input>

        </ion-item>

        <!-- normal case for city and neighborhood dropdown style -->
        <ion-item class="item-bordered" *ngIf="question.id !== 'store_id'">

          <ion-input label-placement="stacked" [value]="getOptionLabel(question)" [label]="question.label"
            placeholder="Seleccione una opción" readonly (click)="openDropdown(question)" [disabled]="_disabled">
          </ion-input>

        </ion-item>

      </ng-container>


        <!-- dropdown -->
        <div class="autocomplete-container">
          <div class="dropdown-container" *ngIf="question.showOptions" (scroll)="onScrollDropdown($event, question)">

            <!-- search-->
            <ion-item>
              <ion-input placeholder="Buscar..." debounce="300" (ionInput)="onAutocompleteSearch($event, question)">
              </ion-input>
            </ion-item>

            <!-- list -->
            <ion-list>

              <!-- otro -->
              <ion-item button *ngIf="question.id === 'neighborhood'" (click)="selectAutocompleteOption({ label: 'Otro', value: 'other' }, question)">
                <b>Selecciona esta opción si no encuentras tu barrio</b>
              </ion-item>

              <ion-item button *ngFor="let option of question.filteredOptions" (click)="selectAutocompleteOption(option, question)">
                {{ option.label }}
              </ion-item>

            </ion-list>

          </div>
        </div>


        <!-- new neighborhood for other -->
        <ion-item *ngIf="showOtherInput && question.id === 'neighborhood'">
          <ion-label position="stacked">Nombre del barrio</ion-label>
          <ion-input type="text" placeholder="Escriba el nombre del barrio" (ionInput)="onOtherNeighborhoodInput($event, question)"></ion-input>
        </ion-item>

      <ion-item *ngSwitchCase="'text'">
        <ion-input *ngIf="question.id === 'document'" [formControl]="question.formControl" (ngModelChange)="onChange(question)" (ngModelChange)="onChangeDocumentValidation(question)"
          [label]="question.label" label-placement="stacked" [type]="question.inputType ? question.inputType : 'text'" appNoSpecialChars
          [name]="question.id" [attr.minlength]="6" [attr.maxlength]="12" [placeholder]="question.placeholder || ''">
        </ion-input>

        <ion-input *ngIf="question.id === 'address'" [formControl]="question.formControl" (ngModelChange)="onChange(question)" [label]="question.label"
          label-placement="stacked" [type]="question.inputType ? question.inputType : 'text'" [name]="question.id" [attr.minlength]="2"
          [attr.maxlength]="50" [placeholder]="question.placeholder || ''">
        </ion-input>

        <ion-input *ngIf="question.id !== 'document' && question.id !== 'address'" [formControl]="question.formControl" (ngModelChange)="onChange(question)"
          [label]="question.label" label-placement="stacked" [type]="question.inputType ? question.inputType : 'text'" appNoSpecialChars
          [name]="question.id" [attr.minlength]="2" [placeholder]="question.placeholder || ''" [attr.maxlength]="50">
        </ion-input>
      </ion-item>

      <ion-item *ngSwitchCase="'email'">
        <ion-input [formControl]="question.formControl" [label]="question.label" label-placement="stacked" [type]="question.inputType ? question.inputType : 'email'"
          appNoSpecialChars [allowAt]="true" [placeholder]="question.placeholder || ''">
        </ion-input>
      </ion-item>

      <ion-item *ngSwitchCase="'tel'">
        <app-input-phone *ngSwitchCase="'tel'" class="expand-input-phone-width" [label]="question.label" label-placement="stacked"
          [value]="question.formControl.value" (valueChange)="question.formControl.setValue($event)" [placeholder]="question.placeholder || 'Seleccione una opción'">
        </app-input-phone>
      </ion-item>

      <ion-item *ngSwitchCase="'date'">
        <ion-input [formControl]="question.formControl" [label]="question.label" label-placement="stacked" type="text" inputmode="text"
          [value]="question.formControl.value" appNoSpecialChars [placeholder]="question.placeholder || ''" [name]="question.id">
        </ion-input>

        <ion-icon aria-hidden="true" name="calendar" slot="end" id="date-{{ question.id }}"></ion-icon>
      </ion-item>

      <ion-item *ngSwitchCase="'time'">
        <ion-input [formControl]="question.formControl" [label]="question.label" type="text" inputmode="text" label-placement="stacked"
          appNoSpecialChars [name]="question.id" [placeholder]="question.placeholder || ''" (ionBlur)="onTimeBlur(question)">
        </ion-input>
        <ion-icon aria-hidden="true" name="time" slot="end" id="time-{{ question.id }}"></ion-icon>
      </ion-item>

      <ion-item *ngSwitchCase="'list-selection'">
        <ion-label position="stacked" [style.color]="question.formControl.touched && question.formControl.invalid? 'var(--ion-color-danger)' : 'black'">
          {{ question.label }}
        </ion-label>
        <ionic-selectable [formControl]="question.formControl" [items]="question.options ? question.options : []" itemValueField="value" [shouldStoreItemValue]="true"
          itemTextField="label" [canSearch]="true" [hasVirtualScroll]="true" (onSearch)="searchQuestionOptions($event, question)"
          searchPlaceholder="Buscar" closeButtonText="Cancelar" closeButtonSlot="end">
          <ng-template ionicSelectableItemTemplate let-port="item" let-isPortSelected="isItemSelected">
            <ion-label>
              <h4>{{ port.label }}</h4>
              <p *ngIf="port.subLabel">{{ port.subLabel }}</p>
            </ion-label>
          </ng-template>
        </ionic-selectable>
      </ion-item>

      <ng-container *ngSwitchCase="'checkbox'">

        <div *ngIf="question.id === firstAllowPromotionalId" class="promotional-title">
          Quiero recibir novedades por
        </div>

        <ion-item lines="none">
          <ion-checkbox labelPlacement="end" aria-labelledby="terms-lbl" [formControl]="question.formControl"></ion-checkbox>

          <ion-label class="ion-padding-start ion-text-wrap" id="terms-lbl">
            {{ question.label }}
          </ion-label>
        </ion-item>

      </ng-container>

    </div>

    <ion-popover *ngIf="!_disabled && question.type === 'date'" trigger="date-{{ question.id }}" side="bottom" alignment="center">
      <ng-template>

        <mat-card class="demo-inline-calendar-card">
          <mat-calendar (selectedChange)="changeDate(question, $event)" [maxDate]="question?.maxDate" [selected]="
              question.formControl.value ? question.formControl.value : question.defaultValue">
          </mat-calendar>
        </mat-card>

      </ng-template>
    </ion-popover>

    <ion-popover *ngIf="!_disabled && question.type === 'time'" trigger="time-{{ question.id }}" side="top" alignment="center">
      <ng-template>
        <ion-datetime locale="es-ES" presentation="time" [value]="question.formControl.value ? question.formControl.value : question.defaultValue"
          [showDefaultButtons]="true" doneText="Aceptar" cancelText="Cancelar" (ionChange)="changeTime(question, $event)">
        </ion-datetime>
      </ng-template>
    </ion-popover>
    <div class="ion-text-center" *ngIf="question.suggestions">
      <ion-chip color="secondary" *ngFor="let suggestion of getTextSuggestions(question)" (click)="selectSuggestion(question, suggestion)">
        {{ suggestion }}
      </ion-chip>
    </div>

    <ion-note class="ion-padding-start" [style.color]="question.formControl.touched ? 'var(--ion-color-danger)' : 'transparent'">
      {{ getErrorText(question) }}
    </ion-note>
  </div>
</ion-list>

<app-multiple-options-modal
  [options]="currentField?.options || []"
  [selected]="selectedValues[currentFieldId]"
  [multiple]="isMultipleSpecialField"
  [openTrigger]="modalOpenTrigger"
  (selectionChange)="handleSelection($event)"
  (close)="modalOpenTrigger = false">
</app-multiple-options-modal>
